import {UI} from "../../../stem-core/src/ui/UIBase.js";

import {PayWithAddedCardComponent} from "../pages/panels/payment-method/components/PayWithAddedCardComponent.jsx";
import {Messages} from "../../Messages.js";
import {MerchantButton} from "../../common/MerchantButton.jsx";
import {PoweredByBlink} from "../PoweredByBlink.jsx";
import {LoadingSpinner} from "../../../core/ui/LoadingSpinner.jsx";
import {Flow} from "../FlowState.js";
import {DONATE_PAGE_URLS} from "../PanelConstants.js";
import {StepDescription} from "./StepDescription.jsx";
import {authService} from "../../../client/connection/Services.js";
import {Controller} from "../Controller.js";


export class PayWithAddedCardPanel extends UI.Element {
    render() {
        return [
            <StepDescription backFunction={() => this.options.changeURL(authService.isAuthenticated() ?
                                    DONATE_PAGE_URLS.donate : DONATE_PAGE_URLS.auth, true)}
                             currentStep={StepDescription.stepCount} stepDescription={Messages.paymentStep}/>,
            <PayWithAddedCardComponent ref="cardComponent" onChange={() => this.redraw()}/>,
            <MerchantButton disabled={!this.cardComponent?.isValid()}
                            onClick={() => this.donate()}>
                {Messages.finalizePayment}
            </MerchantButton>,
            <PoweredByBlink/>
        ];
    }

    donate() {
        LoadingSpinner.show();

        this.cardComponent.getPaymentMethodId(Controller.paymentMethod.getScope(), preferredPaymentMethodId => {
            let payload = {
                amount: Flow.donation.getTotalAmount(),
                frequency: Flow.donation.getFrequency(),
                coversFees: Flow.donation.payDonationFeeCheckboxChecked,
            };
            if (preferredPaymentMethodId) {
                payload.preferredPaymentMethodId = preferredPaymentMethodId
            }
            Flow.donation.setPayload(payload);
            Flow.donation.donate(() => this.options.changeURL(DONATE_PAGE_URLS.thankYou),
                () => this.options.changeURL(DONATE_PAGE_URLS.paymentFailed, true));
        }, () => {
            // Error rendering is done in the card component.
            LoadingSpinner.hide();
        });
    }

    onMount() {
        authService.onAuthenticationChange(() => {
            if (this.isInDocument() && !authService.isAuthenticated()) {
                this.options.changeURL(DONATE_PAGE_URLS.donate, true);
            }
        });
    }
}
